import {Component, EventEmitter, Input, Output, ElementRef, OnInit, OnChanges, SimpleChanges} from '@angular/core';
import { CommonServices } from '../../../shared/services/src/api';
import * as _ from 'lodash';
import { StringUtils} from '../../../shared/utils/src/string.utils';
import { ValidatorUtils} from '../../../shared/utils/src/validator.utils';

@Component({
    selector: 'simple-select',
    templateUrl: './select.component.html',
    styleUrls : [
        './element.select.scss',
        './component.custom-select.scss'
    ]
})
export class SelectComponent implements OnInit, OnChanges {
    @Input() layoutstyleClass: any; // 버튼에 특정 레이아웃을(width가 100%라든가...)를 고정으로 부여햘 필요가 있을떄
    @Input() maxWidth: any;          // 개별로 최대 넓이를 지정할때가 있는데 일일히 css class로 바인딩하기 어렵다.
    @Input() minWidth: any;          // 개별로 최소 넓이를 지정할때가 있음
    @Input() optgroup: any;
    @Input() disabled: any;          // 상위 엘리먼트에서 disabled 처리를 할때 사용
    @Input()
    public set selectConfig(conf: any){
        if (!conf.getCode) {
            this._selectConfig = conf;
        }else {
            this._commonServices.getCode(conf.getCode).then(result => {
                if (result.status === 200) {
                    result.json().data.forEach((_data: any) => {
                        this._option.push({
                            label: _data.dispNm,
                            value: _data.cdId
                        });
                    });
                    conf.option =  this._option;
                    this._selectConfig = conf;
                }
            });
        }
    }

    @Input() public selectedvalue: string;
    @Input() public viewTextOnly = false;
    @Output() public selectChanged: EventEmitter<any> = new EventEmitter();

    private _option: Array<any> = [];
    private _selectConfig: any = {};
    private element: any;

    public mirrorTextForDisabled: any;      // disabled일때 보여주려고...

    public get selectConfig(): any {
        return this._selectConfig;
    }

    _selectedValue = '';
    @Input() isInvalid: boolean;
    selectedYN = false;     ///권한에 따르 selectconfig의 option리스트에 해당 항목이 없는경우가 발생할경우 validation에 문제가 생김. 이를 해결하기 위하여 selectedYN란 변수를 생성하고 셀렉트박스를 변경할때 true로 바꾼후 validation에서 false인경우 invalid로 처리

    constructor(private _commonServices: CommonServices,
                element: ElementRef) {
        this.element = element.nativeElement;
    }

    ngOnInit() {
        if (this.selectedvalue && this.selectedvalue !== '-' ) {
            this._selectedValue = this.selectedvalue;
            try {
                //this.mirrorTextForDisabled = _.find(this._selectConfig.option, {'value': this.selectedvalue})['label'];
                this.selectedYN = false;
                this._selectConfig.option.forEach((data: any) => {
                    if (data.value.toString() === this.selectedvalue.toString()) {
                        if (data.DisabledText) {
                            this.mirrorTextForDisabled = data.DisabledText;
                        } else {
                            this.mirrorTextForDisabled = data.label;
                        }
                        this.selectedYN = true;
                        return;
                    }
                });
            } catch (e) {
                console.error(`[${e.name}] : ${e.message}   [option]:${JSON.stringify(this._selectConfig)} [value]:${this.selectedvalue}`);              // some Message
            }
        }

    }

    ngOnChanges(changes: SimpleChanges) {
        const targetChange = changes['selectedvalue'];
        if (targetChange && !targetChange.firstChange) {
            if (this.selectedvalue && this.selectedvalue !== '-') {
                this._selectedValue = this.selectedvalue;
                try {
                    //this.mirrorTextForDisabled = _.find(this._selectConfig.option, {'value': this.selectedvalue})['label'];
                    this._selectConfig.option.forEach((data: any) => {
                        if (data.value.toString() === this.selectedvalue.toString()) {
                            if (data.DisabledText) {
                                this.mirrorTextForDisabled = data.DisabledText;
                            } else {
                                this.mirrorTextForDisabled = data.label;
                            }
                            this.selectedYN = true;
                            return;
                        }
                    });
                } catch (e) {
                    console.error(`[${e.name}] : ${e.message}   [option]:${JSON.stringify(this._selectConfig)} [value]:${this.selectedvalue}`);              // some Message
                }
            }
        }

    }

    public selectChange(event) {
        this.selectedYN = true;
        this._selectedValue = event.target.value;
        this.selectChanged.emit(event.target.value);
    }

    public validation() {
        this.isInvalid = false;
        if (StringUtils.isEmpty(this._selectedValue.toString()) || !this.selectedYN ) {
            this.isInvalid = true;
        }
        return !this.isInvalid;
    }

    public setInvalid() {
        this.isInvalid = false;
    }

    public getValue() {
        return $(`#${this.selectConfig.id}`).val();
    }

    public getSelectedValue() {
        return this._selectedValue;
    }

    public getSelectedLabel() {
       return _.find(this.selectConfig.option, {'value': this._selectedValue})['label'];
        // return this._selectedValue;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/form/select/select.component.ts